module.exports = __webpack_public_path__ + "img/online_bg_2023_01_19_2.6b026469.png";